export default __webpack_public_path__ + "static/media/September2020.4b9de010.png";